const routeLoaders = {
  '/safety-regulations': () => import('../pages/SafetyRegulations'),
  '/safety-materials': () => import('../pages/SafetyMaterialsHub'),
  '/safety-forms': () => import('../pages/SafetyFormsPage'),
  '/field-qna': () => import('../pages/FieldQnAList'),
  '/board': () => import('../pages/BoardList'),
  '/search': () => import('../pages/SearchResults'),
};

const prefetchedRoutes = new Set();

export const prefetchRoute = (path) => {
  const loader = routeLoaders[path];
  if (!loader || prefetchedRoutes.has(path)) return;
  prefetchedRoutes.add(path);
  loader().catch(() => prefetchedRoutes.delete(path));
};

export const prefetchPrimaryRoutesWhenIdle = () => {
  if (typeof window === 'undefined') return () => {};
  const connection = navigator.connection || navigator.mozConnection || navigator.webkitConnection;
  if (connection?.saveData || /(^|-)2g$/.test(connection?.effectiveType || '')) return () => {};

  let cancelled = false;
  const paths = ['/board', '/field-qna', '/safety-regulations', '/safety-materials', '/safety-forms'];
  const loadNext = () => {
    if (cancelled) return;
    const path = paths.shift();
    if (!path) return;
    prefetchRoute(path);
    window.setTimeout(loadNext, 250);
  };
  const start = () => window.setTimeout(loadNext, 400);
  const idleId = window.requestIdleCallback
    ? window.requestIdleCallback(start, { timeout: 2500 })
    : window.setTimeout(start, 1200);

  return () => {
    cancelled = true;
    if (window.cancelIdleCallback && typeof idleId === 'number') window.cancelIdleCallback(idleId);
    else window.clearTimeout(idleId);
  };
};
